import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import IconBtn from '../../microComponents/elements/IconBtn';
import {getAgainHandler} from '../../store/TableRedux/TableRedux';
import {FaPlus} from "react-icons/fa6";

import {AutoComplete, Button, Form, Input, InputNumber, Modal, Radio, Switch} from 'antd';
import {toast} from "react-toastify";
import Product from "../../http_request/Model/product/Product";
import {IoPencil} from "react-icons/io5";
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";

const UpdateCreateCategory = ({rowData, selectedRowKeys}) => {

    const dispatch = useDispatch();
    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const showModal = () => {
        form.resetFields()
        setOpen(true);
    };
    useEffect(() => {
        if (selectedRowKeys.length === 1) {

            form.setFieldsValue(rowData[0])
        } else {


            form.resetFields()
            form.setFieldsValue({status: true, exireDateInDays: false,})
        }


    }, [rowData.length, rowData, open,form, selectedRowKeys.label, selectedRowKeys])


    const handleCancel = () => {

        setOpen(false);

    };

    useEffect(() => {
        getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)
    }, [])


    const onFinish = (values) => {
values.consumerPriceRials = Number(values.consumerPriceRials)
values.manufacturerPriceRials = Number(values.manufacturerPriceRials)

        if (selectedRowKeys.length > 1) {

            let data = {}
            data.products = values
            data.codes = selectedRowKeys
            Product.request({
                beforeSend: () => {
                    setLoading(true)

                }, success: () => {
                    toast.success('تغییرات با موفقیت اعمال شد.');
                    dispatch(getAgainHandler())
                    handleCancel()
                    form.resetFields()
                }, error: (error) => {
                    toast.error(error.data.message);

                }, final: () => {
                    setLoading(false)

                },


            }).editProducts(data);

        } else {
            Product.request({
                beforeSend: () => {
                    setLoading(true)

                }, success: () => {
                    toast.success('تغییرات با موفقیت اعمال شد.');
                    dispatch(getAgainHandler())
                    handleCancel()
                    form.resetFields()
                }, error: (error) => {
                    toast.error(error.data.message);

                }, final: () => {
                    setLoading(false)

                },


            }).updateCreateProduct(values, rowData.length ? 'put' : 'post', rowData[0]?.code);
        }


    };
    const onFinishFailed = () => {
    };


    return (<>
            {/*{hasPermission('category', ['create']) && (*/}
            <IconBtn TooltipText={rowData.length ? 'ویرایش' : 'ایجاد'}
                     color={rowData.length ? 'orangeIconBtn' : 'greenIconBtn'}

                     onClick={showModal}>


                {rowData.length ? <IoPencil/>
                    : <FaPlus/>}
            </IconBtn>


            <Modal
                width={900}
                open={open}
                title={`${rowData.length ? 'ویرایش' : 'ایجاد'}  محصول `}
                onCancel={handleCancel}
                footer={[<Button className='defBtn redBtn' key="back" onClick={handleCancel}>
                    انصراف
                </Button>, <Button key="submit" type="primary" className='defBtn blueBtn !px-4' loading={loading}
                                   onClick={() => {
                                       form.submit()
                                   }}>
                    ثبت
                </Button>,

                ]}
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}

                    onFinishFailed={onFinishFailed}
                >


                    <div className="grid grid-cols-4 gap-4 mt-10">

                        <Form.Item name="type" label="نوع"
                                   rules={[{required: selectedRowKeys.length < 2, message: 'لطفا نوع را وارد کنید!',},]}
                        >


                            <AutoComplete
loading={filterDetailsListLoading}
                                options={filterDetailsList?.type}

                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />


                        </Form.Item>
                        {
                            selectedRowKeys.length < 2 && <>

                                <Form.Item label="کد" name="code"
                                           rules={[{
                                               required: selectedRowKeys.length < 2,
                                               message: 'لطفا کد را وارد کنید!',
                                           },]}>
                                    <Input/>
                                </Form.Item>

                                <Form.Item label="نام" name="name"
                                           rules={[{
                                               required: selectedRowKeys.length < 2,
                                               message: 'لطفا نام را وارد کنید!',
                                           },]}>
                                    <Input/>
                                </Form.Item>
                            </>
                        }

                        <Form.Item label="وضعیت" name="status" valuePropName="checked"
                                   rules={[{
                                       required:selectedRowKeys.length < 2,
                                       message: 'لطفا وضعیت را وارد کنید!',
                                   },]}>

                            <Switch defaultValue={true} defaultChecked={true} checkedChildren='فعال'
                                    unCheckedChildren='غیر فعال'/>
                        </Form.Item>

                        <Form.Item label="تعداد در پالت" name="quantityPerPallet"
                                   rules={[{
                                       required: selectedRowKeys.length < 2,
                                       message: 'لطفا تعداد در پالت را وارد کنید!',
                                   },]}>

                            <Input type='number'/>
                        </Form.Item>
                        <Form.Item label="واحد اندازه گیری" name="unitMeasurement"
                                   rules={[{
                                       required: selectedRowKeys.length < 2,
                                       message: 'لطفا واحد اندازه گیری را وارد کنید!',
                                   },]}>

                            <AutoComplete

                                options={filterDetailsList?.unitMeasurement}
                                loading={filterDetailsListLoading}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />
                        </Form.Item>
                        <Form.Item label="زمان انقضا" name="expiryDate"
                                   rules={[{
                                       required: selectedRowKeys.length < 2,
                                       message: 'لطفا زمان انقضا را وارد کنید!',
                                   },]}>

                            <Input type='number'/>
                        </Form.Item>
                        <Form.Item name="exireDateInDays" label=' ' valuePropName="checked"
                        >

                            <Radio.Group defaultValue={false}>
                                <Radio value={true}> روز </Radio>
                                <Radio value={false}> ماه </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item name="brand" label="برند"
                        >
                            <AutoComplete

                                options={filterDetailsList?.brand}
                                loading={filterDetailsListLoading}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />

                        </Form.Item>
                        <Form.Item name="taste" label="طعم"
                        >
                            <AutoComplete

                                options={filterDetailsList?.taste}
                                loading={filterDetailsListLoading}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />

                        </Form.Item>
                        <Form.Item name="consumerPriceRials" label="قیمت مصرف کننده"
                        >
                            {/*<Input type='number'/>*/}

                            <InputNumber className='w-full'
                                 formatter={value => `  ${value} `.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                             />

                        </Form.Item>
                        <Form.Item name="manufacturerPriceRials" label="قیمت تولید کننده"
                        >
                            <InputNumber className='w-full'
                                         formatter={value => `  ${value} `.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            />

                        </Form.Item>


                        <Form.Item name="expireDateThreshold" label=" آستانه انقضا (روز)"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="fifoThresholdDay" label="آستانه FIFO"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="orderPoint" label="نقطه سفارش"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="pakingType" label="نوع بسته بندی"
                        >
                            <Input/>

                        </Form.Item>
                        <Form.Item name="weight" label="وزن"
                        >
                            <Input type='number'/>

                        </Form.Item>


                        <Form.Item name="length" label="طول"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="width" label="عرض"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="height" label="ارتفاع"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="volumeCc" label="حجم"
                        >
                            <Input type='number'/>

                        </Form.Item>
                        <Form.Item name="layout" label="چیدمان"
                        >
                            <Input/>

                        </Form.Item>
                        <Form.Item name="maxFloor" label="حداکثر طبقه"
                        >
                            <Input type='number'/>

                        </Form.Item>


                        {/*<Form.Item label="محل دسترسی" name="accessLocation">*/}
                        {/*    <Input/>*/}
                        {/*</Form.Item>*/}


                    </div>


                </Form>

            </Modal>


        </>

    );
};

export default UpdateCreateCategory;
